import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetOffersQueryResponse } from "../utils/types";
import { MyStayType } from "../utils/types/offers";

const useGetMyStayServices = (data?: { page: number; perPage: number }): IUseGetOffersQueryResponse => {
  return useQuery({
    queryKey: ["my-stay-services", data?.page, data?.perPage],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get(`v1/coupons?myStayType=${MyStayType.SERVICE}`, {
        params: data,
      });
      return response.data;
    },
  });
};

export default useGetMyStayServices;
